import { Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@orisini/ui/context/AuthContext'
import AppShell from './components/layout/AppShell'
import ProtectedRoute from './components/layout/ProtectedRoute'
import AccountsPage from './features/accounts/pages/AccountsPage'
import AgentPage from './features/agent/pages/AgentPage'
import BillingPage from './features/billing/pages/BillingPage'
import CalendarPage from './features/calendar/pages/CalendarPage'
import HistoryPage from './features/history/pages/HistoryPage'
import DashboardPage from './features/dashboard/pages/DashboardPage'
import HealthPage from './features/dev/pages/HealthPage'
import PostEditorPage from './features/posts/pages/PostEditorPage'
import PostsPage from './features/posts/pages/PostsPage'
import SettingsPage from './features/settings/pages/SettingsPage'
import SlotsPage from './features/slots/pages/SlotsPage'

/**
 * Router Gramium.
 *
 * Tidak ada route /login, /register, maupun /admin untuk user: semuanya milik
 * orisini.com. Gramium hanya berisi halaman yang benar-benar tentang Instagram.
 *
 * Pengecualiannya /billing: halamannya ADA di sini supaya user bisa berlangganan
 * tanpa berpindah domain, tapi isinya hanya panel bersama dari @orisini/ui yang
 * memanggil `/api/billing/*` — dan Worker Gramium meneruskan semuanya ke
 * orisini. Order, uang, dan verifikasinya tetap milik orisini.
 *
 * `idOrigin` memberi tahu AuthContext ke mana harus mengarahkan pengunjung yang
 * kehabisan sesi. Ia dibaca dari variabel build supaya development
 * (gramium.orisini.amano) dan produksi tidak perlu kode berbeda.
 */
const ID_ORIGIN = import.meta.env.VITE_ID_ORIGIN ?? 'https://orisini.com'

export default function App() {
  return (
    <AuthProvider idOrigin={ID_ORIGIN}>
      <Routes>
        <Route path="/_health" element={<HealthPage />} />

        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="posts" element={<PostsPage />} />
          <Route path="posts/:id" element={<PostEditorPage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="slots" element={<SlotsPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="agent" element={<AgentPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<TidakDitemukan />} />
        </Route>
      </Routes>
    </AuthProvider>
  )
}

function TidakDitemukan() {
  return (
    <div className="space-y-2">
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-sm text-muted-foreground">Check the address again.</p>
    </div>
  )
}
